
import React from 'react';

interface PlaceholderTabContentProps {
  message: string;
}

const PlaceholderTabContent: React.FC<PlaceholderTabContentProps> = ({ message }) => {
  return (
    <div className="py-10 text-center">
      <p className="text-gray-500">{message}</p>
    </div>
  );
};

export default PlaceholderTabContent;
